// extracted by mini-css-extract-plugin
export default {"pop":"PopUp_pop__PjMVj","pop_open":"PopUp_pop_open__S0x61","card":"PopUp_card__SbiqW","cross":"PopUp_cross__0ctJ8"};